class ModalManager extends HTMLElement {
  constructor() {
    super();

    // Bind event handlers to ensure correct `this` context
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

    // Overlay element (assumes a child of the custom element or globally accessible)
    this.overlay =
      this.querySelector("#overlay-element") ||
      document.getElementById("overlay-element");
  }

  connectedCallback() {
    // Find all modal buttons within the custom element's scope
    this.modalButtons = this.querySelectorAll(".product-trustbuilder-modal");
    this.modals = this.querySelectorAll(".product-trustbuilder-content");

    // Attach event listeners to buttons
    this.modalButtons.forEach((button) =>
      button.addEventListener("click", this.openModal)
    );

    // Attach event listener to overlay for closing modals
    if (this.overlay) {
      this.overlay.addEventListener("click", this.closeModal);
    }

    // Attach event listeners to all close buttons inside modals
    this.modals.forEach((modal) => {
      const closeButton = modal.querySelector(".close-modal-btn");
      if (closeButton) {
        closeButton.addEventListener("click", this.closeModal);
      }
    });
  }

  disconnectedCallback() {
    // Clean up event listeners
    this.modalButtons.forEach((button) =>
      button.removeEventListener("click", this.openModal)
    );
    if (this.overlay) {
      this.overlay.removeEventListener("click", this.closeModal);
    }
  }

  openModal(event) {
    const button = event.currentTarget;
    const modalId = button.dataset.modal;
    const modal =
      this.querySelector(`#${modalId}`) || document.getElementById(modalId);

    if (modal) {
      this.activeModal = modal;
      modal.classList.remove("hidden");
      if (this.overlay) {
        this.overlay.classList.remove("hidden");
      }
      this.disableScrolling();
    }
  }

  closeModal() {
    if (this.activeModal) {
      this.activeModal.classList.add("hidden");
      if (this.overlay) {
        this.overlay.classList.add("hidden");
      }
      this.activeModal = null;
      this.enableScrolling();
    }
  }

  disableScrolling() {
    document.body.style.overflow = "hidden";
  }

  enableScrolling() {
    document.body.style.overflow = "";
  }
}

// Define the custom element
customElements.define("modal-manager", ModalManager);
